module.exports = __webpack_public_path__ + "e-commerce.svg?8b13d66d00fb6c420928731bc9961ed7";


//////////////////
// WEBPACK FOOTER
// ./public/img/products/e-commerce.svg
// module id = 565
// module chunks = 3